import DatabaseSqlite from "better-sqlite3";
import Database from "./Database";
import DownloadManager from "../Entity/DownloadManager";

export default class DownloadManagerRepository {
    private database: DatabaseSqlite.Database;

    public constructor(
        database: Database
    ) {
        this.database = database.getDatabase();
    }

    public getById(id: number): DownloadManager | null {
        try {
            const select = this.database.prepare("SELECT * FROM downloadManager WHERE id = ?;");
            const row: any = select.get(id);
            if (row) {
                return this.createDownloadManagerFromRow(row);
            }
        } catch (error) {
            console.error("Error when attempting to retrieve the downloadManager by ID:", error);
        }

        return null;
    }

    private createDownloadManagerFromRow(row: any): DownloadManager {
        return new DownloadManager(row.id, row.name, row.type, row.status);
    }

    public save(downloadManager: DownloadManager): void {
        this.getById(downloadManager.getId()) ? this.update(downloadManager) : this.insert(downloadManager);
    }

    private insert(downloadManager: DownloadManager): void {
        try {
            const insert = this.database.prepare("INSERT OR IGNORE INTO downloadManager (id, name, type, status) VALUES (?,?,?,?)");
            insert.run(downloadManager.getId(), downloadManager.getName(), downloadManager.getType(), downloadManager.getStatus());
        } catch (error) {
            console.error("Error when attempting to insert the downloadManager:", error);
        }
    }

    private update(downloadManager: DownloadManager): void {
        try {
            const update = this.database.prepare("UPDATE downloadManager SET name = ?, type = ?, status = ? WHERE id = ?");
            update.run(downloadManager.getName(), downloadManager.getType(), downloadManager.getStatus(), downloadManager.getId());
        } catch (error) {
            console.error("Error when attempting to update the downloadManager:", error);
        }
    }

    public remove(id: number) {
        try {
            const remove = this.database.prepare("DELETE FROM downloadManager WHERE id = ?");
            remove.run(id);
        } catch (error) {
            console.error("Error when attempting to delete the downloadManager:", error);
        }
    }
}
